export default __webpack_public_path__ + "static/media/Online payment_Two Color.a54c49d5.svg";